<template>
  <div id="location-form">
    <div class="form-group row">
      <label for="inputIP" class="col-sm-2 col-form-label">IP</label>
      <div class="col-sm-10">
        <input
          id="inputIP"
          class="form-control"
          v-model="location.ip"
          :disabled="!create"
          :readonly="!create"
          :class="!create ? 'is-static' : ''"
          type="text"
          placeholder="IP"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputFacility" class="col-sm-2 col-form-label">Facility</label>
      <div class="col-sm-10">
        <input id="inputFacility" class="form-control" v-model="location.facility" type="text" placeholder="Facility" />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputPoc" class="col-sm-2 col-form-label">Point Of Care</label>
      <div class="col-sm-10">
        <input
          id="inputPoc"
          class="form-control"
          v-model="location.pointOfCare"
          type="text"
          placeholder="Point Of Care"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputBuilding" class="col-sm-2 col-form-label">Building</label>
      <div class="col-sm-10">
        <input id="inputBuilding" class="form-control" v-model="location.building" type="text" placeholder="Building" />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputFloor" class="col-sm-2 col-form-label">Floor</label>
      <div class="col-sm-10">
        <input id="inputFloor" class="form-control" v-model="location.floor" type="text" placeholder="Floor" />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputRoom" class="col-sm-2 col-form-label">Room</label>
      <div class="col-sm-10">
        <input id="inputRoom" class="form-control" v-model="location.room" type="text" placeholder="Room" />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputBed" class="col-sm-2 col-form-label">Bed</label>
      <div class="col-sm-10">
        <input id="inputBed" class="form-control" v-model="location.bed" type="text" placeholder="Bed" />
      </div>
    </div>
    <div class="form-group row">
      <label for="inputBed" class="col-sm-2 col-form-label">Full Bed Name</label>
      <div class="col-sm-10">
        <input
          id="inputFullBedName"
          class="form-control"
          v-model="location.fullBedName"
          type="text"
          placeholder="Full Bed Name"
        />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12 text-right">
        <hr />
        <button id="btn-location-form-cancel" class="btn btn-light" @click="cancelAction()">
          {{ cancelTitle }}
        </button>
        <button id="btn-location-form-save" class="btn btn-primary" @click="successAction()">
          {{ successTitle }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationForm",
  props: ["location", "create", "successAction", "cancelAction", "successTitle", "cancelTitle"]
};
</script>
